import { MUTATION_GROUP } from './constants.tsx';
import type { JiraWikiTextFieldInput } from './types.tsx';

export const mutateTextAreaField = (
	value: string,
	fieldId: string,
): JiraWikiTextFieldInput | null => ({
	fieldId,
	mutationGroup: MUTATION_GROUP,
	richText: {
		wikiText: value,
	},
});
